export type GraphicsDeviceKind = 'webgpu' | 'webgl2';

export interface GraphicsDevicePolicyInput {
  isTablet: boolean;
  isTouchMode: boolean;
  isIosWebKit: boolean;
  forceWebGpu: boolean;
}

export function detectIosWebKit(
  userAgent = navigator.userAgent,
  maxTouchPoints = navigator.maxTouchPoints,
): boolean {
  return /iP(?:ad|hone|od)/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1);
}

export function resolveGraphicsDeviceOrder(input: GraphicsDevicePolicyInput): GraphicsDeviceKind[] {
  if (input.forceWebGpu) return ['webgpu', 'webgl2'];
  if (input.isIosWebKit || input.isTablet || input.isTouchMode) return ['webgl2'];
  return ['webgpu', 'webgl2'];
}
